<template>
    <div class="Dropdown">
        <select class="Selector" :id="elementID" :disabled="disabled" @change="OnChange">
            <option class="localize" v-for="option in options" :data-key="option.locakey" :key="option.value" :selected="option.selected ? 'true' : null" :value="option.value" :disabled="option.disabled"> {{ option.label }} </option>
        </select>
    </div>
</template>

<script>
export default{
    props:
    {
        options: Array,
        elementID: String,
        disabled: Boolean,
        OnChange: Function,
        SelectedIndex: Number,
    },
    mounted(){
        this.$nextTick(() => {
            const t = document.getElementById(this.elementID);
            if (t !== null && t.options.length > this.SelectedIndex)
            {
                t.options[this.SelectedIndex].selected = true;
            }
        });
    },
};
</script>

<style>
.Dropdown
{
    display: inline-block;
    position: relative;
    /* margin-right: 45px; */
}

.Dropdown select {
    appearance: none;
    width: 100%;
    padding: 0.675em 6em 0.675em 1em;
    background-color: white;
    border: 1px solid rgb(223, 223, 223);
    border-radius: 10px;
    padding: 4px 8px;
    padding-right: 30px;
    font-size: 0.95rem;
    color: #000;
    cursor: pointer;
}

.Dropdown::before,
.Dropdown::after {
    --size: 0.3rem;
    position: absolute;
    content: "";
    right: 1rem;
    pointer-events: none;
}

.Dropdown::before {
    border-left: var(--size) solid transparent;
    border-right: var(--size) solid transparent;
    border-bottom: var(--size) solid black;
    top: 40%;
}

.Dropdown::after {
    border-left: var(--size) solid transparent;
    border-right: var(--size) solid transparent;
    border-top: var(--size) solid black;
    top: 55%;
}
</style>